export function Primary(target: any, propertyKey: string) {
	target.constructor.primaryKey = propertyKey;
}